import {useEffect} from 'react';
import {useAssetStats} from '../Components/Context/Assets/AssetStatsContext';
import {useSelector} from 'react-redux';
import {ProjectDirtySelector} from '../Selectors';

const useBeforeUnload = () => {
  const {
    state: {hiresPercentage, total},
  } = useAssetStats();
  const projectDirty = useSelector(ProjectDirtySelector);

  useEffect(() => {
    const eventHandler = (e: BeforeUnloadEvent) => {
      switch (true) {
        // If some files have been added but don't have the hires yet (if using AI then it may take a while)
        // or uploading is still progress
        // or the project has unsaved changes
        // then show an alert.
        case hiresPercentage < 100 && total > 0:
        case projectDirty: {
          e.preventDefault();
          e.returnValue = '';
          break;
        }
      }
    };
    window.addEventListener('beforeunload', eventHandler, true);
    return () => {
      window.removeEventListener('beforeunload', eventHandler, true);
    };
  }, [hiresPercentage, total, projectDirty]);
};

export default useBeforeUnload;
